import Link from "next/link";
import React from "react";

import Styles from "./Legal.styles";
import { LegalProps as Props } from "./Legal.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import useI18n from "hooks/useI18n";

const Legal: React.FC<Props> = props => {
  const t = useI18n();

  return (
    <Styles className="Legal">
      <header className="Legal__header">
        <Navbar showBrand />
      </header>
      <main className="Legal__main">
        <ProfileNavigation className="Legal__profile-navigation" />
        <section className="Legal__content">
          <GoBack className="Legal__go-back" title="Atrás" />
          <div className="Legal__container">
            <h1 className="Legal__title">{t.terms.legalTerms}</h1>
            <p className="Legal__paragraph">
              Los siguientes términos y condiciones regulan el uso del sitio web
              y la aplicación móvil (en adelante {`"Plataforma Virtual"`}) que
              es manejada por SUSHICORP S.A.S (en adelante {`"SUSHICORP"`}), los
              cuales contienen las reglas que rigen la relación comercial de los
              consumidores con SUSHICORP, especialmente la autorización sobre el
              uso de la Plataforma Virtual a favor de los consumidores y
              usuarios.
            </p>
            <p className="Legal__paragraph">
              Al acceder o utilizar la Plataforma Virtual usted está aceptando
              los términos y condiciones aquí establecidos. SUSHICORP se reserva
              su derecho de modificar, con o sin previo aviso, en cualquier
              momento el contenido de los mismos. Por lo que, para continuar
              usando esta Plataforma Virtual, le recomendamos leer atentamente
              los términos y condiciones aquí contenidos. Esta Plataforma
              Virtual es de uso libre y gratuito, su simple acceso no constituye
              la creación de una relación comercial entre SUSHICORP y el
              usuario. SUSHICORP, con o sin previo aviso, podrá actualizar la
              Plataforma Virtual o suspenderla en todo o en parte, así como
              impedir el uso de la misma. El uso de cualquiera de las
              actualizaciones de la Plataforma Virtual constituye aceptación de
              los cambios en la misma, así como de estos términos y condiciones
              y cualquiera de sus reformas futuras.
            </p>
            <p className="Legal__paragraph">
              Los usuarios y consumidores entienden que ciertas ofertas,
              servicios y características que pueden estar disponibles en la
              Plataforma Virtual podrán estar sujetos a términos y condiciones
              específicos que deberán ser leídos y aceptados por los usuarios y
              consumidores, lo que puede incluir programas de lealtad y
              recompensas. En el caso de que presente una contradicción entre
              estos términos y condiciones y los términos y condiciones
              específicos, prevalecerán los términos y condiciones específicos.
              El usuario entiende que algunas ofertas, servicios y funciones
              podrán estar disponibles en la versión página web de la Plataforma
              Virtual y no en la versión de la aplicación móvil y viceversa.
            </p>
            <p className="Legal__paragraph">
              Todos los derechos de autor y demás derechos de propiedad
              intelectual referentes a las imágenes, texto y material contenido
              en la Plataforma Virtual es de propiedad exclusiva de SUSHICORP,
              quien únicamente autoriza a sus usuarios el uso personal del
              contenido de esta Plataforma Virtual, quedando expresamente
              prohibido su uso comercial sin autorización y por ninguna razón se
              entenderá cedida con el solo acceso o uso de la Plataforma
              Virtual. Este portal puede contener información y contenido de
              terceros, el cual está protegido de igual manera por los derechos
              de autor y demás derechos de propiedad intelectual y su uso
              comercial está prohibido. SUSHICORP no se hace responsable por el
              mal uso de la información o contenido de la Plataforma Virtual.
              Queda prohibido a los usuarios y consumidores la reproducción,
              copia o distribución del texto, música, imágenes, datos,
              hipervínculos, pantallas y en general cualquier contenido de la
              Plataforma Virtual.
            </p>
            <p className="Legal__paragraph">
              Para el uso de la Plataforma Virtual, los usuarios deben observar
              las siguientes reglas:
            </p>
            <div className="Legal__paragraph">
              <ul className="Legal__list-items">
                <li>
                  No utilizará la Plataforma Virtual o cualquiera de sus
                  características electrónicas de comunicación para compartir
                  contenido ilegal, dañino, tortuoso, difamatorio, calumnioso,
                  obsceno, invasivo de la privacidad de otra persona,
                  amenazante, abusivo, odioso, racista, pornográfico, que incite
                  a actos criminales o abusivos, o para propósitos censurables o
                  inapropiados.
                </li>
                <li>
                  Se prohíbe cargar, publicar, reproducir o distribuir cualquier
                  información, software u otro material protegido por derechos
                  de autor o cualquier otro derecho de propiedad intelectual
                  (así como los derechos de publicidad y privacidad) sin obtener
                  primero el permiso del propietario de tales derechos.
                </li>
                <li>
                  Se prohíbe recopilar o almacenar datos personales de otros
                  usuarios.
                </li>
                <li>
                  Se prohíbe utilizar la Plataforma Virtual para fines
                  comerciales sin contar previamente con la autorización por
                  escrito de SUSHICORP.
                </li>
                <li>
                  Queda prohibido cargar, enviar por correo electrónico, incluir
                  en los mensajes o transmitir cualquier material que contenga
                  publicidad no solicitada, virus, archivos corruptos, software,
                  enlaces a otros sitios o cualquier otro código informático,
                  archivos o programas que puedan afectar adversamente,
                  interrumpir, limitar o interferir con el funcionamiento de la
                  Plataforma Virtual de SUSHICORP o el ordenador o dispositivo
                  de cualquier tercero. Asimismo, acepta que usted no va a
                  compartir o publicar cualquier contenido que atente contra el
                  funcionamiento de la Plataforma Virtual o cualquiera de sus
                  características.
                </li>
                <li>
                  SUSHICORP, sin previo aviso, podrá dar de baja la cuenta del
                  usuario que incumpla con alguna de las obligaciones
                  anteriormente mencionadas.
                </li>
              </ul>
            </div>
            <p className="Legal__paragraph">
              SUSHICORP no necesariamente supervisa el contenido e información
              publicada o compartida en la Plataforma Virtual por terceros. Por
              lo que, SUSHICORP no se hace responsable por dicho contenido e
              información publicada por sus usuarios o terceros.
            </p>
            <p className="Legal__paragraph">
              La Plataforma Virtual podría no funcionar con todos los
              ordenadores, navegadores, dispositivos o todos los operadores de
              telefonía móvil. Por lo que, SUSHICORP no hace ninguna declaración
              de que la Plataforma Virtual será compatible con todos los
              ordenadores, navegadores, dispositivos u operadores de telefonía
              móvil. Para la correcta funcionalidad de la Plataforma Virtual,
              incluyendo los servicios basados en la localización, SUSHICORP
              requerirá información proporcionada por el usuario, incluyendo,
              sin limitación, nombre de usuario y contraseña, dirección, e-mail
              y/o localización GPS.
            </p>
            <p className="Legal__paragraph">
              El contenido e información introducidos por los usuarios de la
              Plataforma Virtual será de propiedad de SUSHICORP. Por lo tanto,
              los usuarios ceden expresamente todos los derechos de propiedad
              intelectual sobre el contenido e información introducido en la
              Plataforma Virtual y autorizan a SUSHICORP a disponer de dicho
              contenido conforme a sus necesidades. La Plataforma Virtual, su
              contenido, actualizaciones, selección, coordinación y disposición
              son propiedad de SUSHICORP y sus licenciantes.
            </p>
            <p className="Legal__paragraph">
              El acceso y uso de la Plataforma Virtual otorga a sus usuarios una
              autorización limitada, no exclusiva y revocable de la información
              y contenido de la Plataforma Virtual. El mal uso del contenido de
              la Plataforma Virtual no es responsabilidad de SUSHICORP. La
              reproducción no autorizada del contenido de la Plataforma Virtual
              constituye una violación a los presente términos y condiciones,
              así como a las leyes que regulan la materia.
            </p>
            <p className="Legal__paragraph">
              La Plataforma Virtual podrá solicitar a sus consumidores y
              usuarios enviar y recibir, a su costo, las comunicaciones
              electrónicas relacionadas con la misma, incluyendo, sin
              limitación, mensajes administrativos, anuncios de servicio,
              informes de datos de diagnóstico y las actualizaciones a la
              Plataforma Virtual de SUSHICORP, del operador de telefonía móvil
              empleado por los usuarios o terceros proveedores de servicios.
            </p>
            <p className="Legal__paragraph">
              La Plataforma Virtual podrá permitir que sus usuarios inicien su
              cuenta a través de Facebook o cualquier otro medio de red social.
              Por lo que, el usuario entiende que SUSHICORP no tiene control
              sobre otras plataformas, no las representa, ni otorga ningún tipo
              de garantía, así como no es responsable de su contenido,
              disponibilidad y servicios.
            </p>
            <p className="Legal__paragraph">
              SUSHICORP podrá ceder a un tercero este acuerdo, en todo o en
              parte, en cualquier momento con o sin previo aviso. Sin embargo,
              el usuario entiende que queda prohibida cualquier tipo de cesión
              de su parte. Los usuarios no podrán intentar invalidar este
              acuerdo, así como no podrán transferir a un tercero cualquiera de
              los derechos y obligaciones que nazca a partir de este acuerdo. El
              uso de la Plataforma Virtual por parte de un tercero a través de
              su ordenador o su dispositivo, no exime al usuario de
              responsabilidad por el mal uso de la Plataforma Virtual.
            </p>
            <p className="Legal__paragraph">
              El usuario acepta recibir notificaciones push desde y en nombre de
              SUSHICORP al momento de hacer uso de la Plataforma Virtual en su
              versión de aplicativo móvil. Las actualizaciones al aplicativo
              móvil de la Plataforma Virtual estarán disponibles para su
              descarga y los cambios a la misma serán con la finalidad de
              mejorar o incluir nuevos desarrollos. A través de este acuerdo
              SUSHICORP le otorga al usuario una licencia que le permite
              descargar y utilizar dichas actualizaciones desde su dispositivo
              móvil.
            </p>
            <p className="Legal__paragraph">
              SUSHICORP es una compañía comprometida con el manejo seguro y
              protección de los datos personales de sus usuarios, por lo que
              toda la información recopilada será tratada con los estándares más
              fuertes de protección y privacidad.
            </p>
            <p className="Legal__paragraph">
              La presente Política de Privacidad está vinculada con los Términos
              y Condiciones del servicio ofertado por SUSHICORP y con la
              Política de Privacidad de la plataforma COMO-SENSE.
            </p>
            <p className="Legal__paragraph">
              La presente Política de Privacidad puede cambiar con el tiempo o
              ser actualizada, para lo cual el Usuario será debidamente
              informado y notificado, solicitando su confirmación de haber
              revisado las actualizaciones y así poder asegurarnos de que está
              de acuerdo con dichos cambios.
            </p>
            <h3 className="Legal__subtitle">TRANSACCIONES Y PRODUCTOS</h3>
            <p className="Legal__paragraph">
              A través de la Plataforma Virtual, los consumidores de SUSHICORP
              pueden adquirir los productos que ofrece esta última para lo cual
              el pago se realizará a través del botón de pagos. El Código
              Orgánico Monetario y Financiero, la de Comercio Electrónico,
              Firmas Electrónicas y Mensajes de Datos, así como la normativa que
              regula este tema en el Ecuador permiten que los usuarios de sitios
              web puedan realizar compras utilizando plataformas tecnológicas,
              debidamente autorizadas y que cumplan con todas las condiciones y
              normas de seguridad que exige la normativa vigente. Por lo que,
              SUSHICORP permite a través de su Plataforma Virtual el uso de
              medio de pagos electrónicos, cuyo servicio es prestado por un
              tercero y no directamente por SUSHICORP. Los consumidos serán
              responsables del pago de los tributos que genere dicha
              transacción, así como de cualquier recargo o costo adicional.
            </p>
            <p className="Legal__paragraph">
              El uso de medios electrónicos de pago incluye proporcionar
              información relevante como número de tarjeta de crédito o débito,
              fecha de vencimiento de la misma, nombre del tarjetahabiente,
              código de seguridad y dirección de facturación. Por lo que, el
              usuario garantiza a SUSHICORP que es el titular de la tarjeta de
              crédito o débito y tiene derecho a utilizarla. A través de la
              presentación de la información antes detallada, el usuario otorga
              al proveedor y a SUSHICORP a realizar la transacción. SUSHICORP
              podrá solicitar la verificación de la información previo a
              confirmar y realizar la transacción correspondiente. SUSHICORP no
              será responsable por el uso que el proveedor de este servicio le
              dé a la información proporcionada por el usuario.
            </p>
            <p className="Legal__paragraph">
              Todas las descripciones, imágenes, características,
              especificaciones, productos y precios de los productos o servicios
              están sujetos a cambios en cualquier momento sin previo aviso. La
              inclusión de cualquier producto o servicio en la Plataforma
              Virtual no implica ni garantiza que estos productos o servicios
              estarán disponibles. SUSHICORP se reserva el derecho, con o sin
              previo aviso, de hacer una o más de las siguientes acciones:
            </p>
            <div className="Legal__paragraph">
              <ul className="Legal__list-items">
                <li>
                  Establecer límites de la cantidad de productos disponibles o
                  de retirar cualquier producto o servicio en cualquier momento;
                </li>
                <li>
                  Fijar condiciones para la aplicación de promociones, cupones,
                  códigos promocionales, u otra promoción similar;
                </li>
                <li>
                  Rechazar o interrumpir la realización de una transacción; y
                </li>
                <li>Negarse a proporcionar cualquier producto o servicio.</li>
              </ul>
            </div>
            <p className="Legal__paragraph">
              Los precios y la disponibilidad de los productos o servicios y
              demás opciones de personalización varían según la ubicación. El
              usuario acepta y entiende que los pedidos a través de la
              Plataforma Virtual se cobrarán al momento de que sean realizados.
              Una vez realizado el pedido, el usuario no podrá solicitar cambios
              en su orden. SUSHICORP receptará la orden y la aceptará enviando
              una notificación de dicha aceptación a su correo electrónico. Una
              vez aceptada la orden, el usuario no podrá solicitar la
              cancelación del pedido. Los pedios a domicilio no podrán ser
              realizados desde el interior de cualquiera de las instalaciones de
              propiedad de SUSHICORP.
            </p>
            <p className="Legal__paragraph">
              SUSHICORP no es responsable por errores de los consumidores en el
              pedido de los productos, así como por errores en los datos de
              dirección que se proporcione para la entrega de los productos a
              domicilio.
            </p>
            <h3 className="Legal__subtitle">POLÍTICAS DE ENVIO Y ENTREGA</h3>
            <p className="Legal__paragraph">
              SUSHICORP al momento de aceptar una orden notificará al usuario
              con el tiempo estimado de llegada, el cual podrá variar de acuerdo
              a factores externos fuera del control de SUSHICORP, tales como:
              clima adverso, tráfico, emergencia mecánica, accidentes, entre
              otros. La entrega de pedidos no podrá demorar más de noventa
              minutos, caso contrario SUSHICORP se compromete a realizar un
              reembolso total del costo del pedido. En caso de que el usuario
              selecciona como forma de pago el efectivo, se obliga a pagar el
              total del pedido al momento de su entrega en la dirección
              proporcionada por el usuario.
            </p>
            <h3 className="Legal__subtitle">
              CUENTAS PERSONALES, CONTRASEÑAS, SEGURIDAD Y PRIVACIDAD
            </h3>
            <p className="Legal__paragraph">
              El uso de la Plataforma Virtual podrá requerir de un registro del
              usuario o solicitar información para participar en ciertas
              funciones o acceder a determinados contenidos. El usuario no está
              obligado en realizar el registro o proporcionar la información
              solicitada por la Plataforma Virtual. Sin embargo, la falta de
              registro o el no suministro de información podría restringir el
              acceso a determinados contenidos o a participar de ciertas
              funciones de la Plataforma Virtual.
            </p>
            <p className="Legal__paragraph">
              En caso de que la Plataforma Virtual requiera de la creación de
              una cuenta o el envío de información en los formularios que
              constan en la Plataforma Virtual, el usuario deberá seguir el
              procedimiento especificado por SUSHICORP y completar los campos
              con información actualizada, completa y exacta. El usuario es el
              único responsable sobre la integridad y exactitud de la
              información proporcionada, cualquier pérdida de la misma será su
              exclusiva responsabilidad.
            </p>
            <p className="Legal__paragraph">
              En el caso de registro, la Plataforma Virtual le solicita que
              ingrese su nombre y una dirección válida de correo electrónico,
              así como que escoja una contraseña. El usuario será el único
              responsable de mantener la confidencialidad de su contraseña y
              cuenta. La cuenta es personal e intransferible. Por lo que,
              SUSHICORP no se hace responsable de datos compartidos por parte
              del usuario. Adicionalmente, el usuario es el único responsable
              del uso de dicha cuenta, incluido la forma de pago, solicitudes,
              pedidos, información de tarjetas de crédito y cualquier otro
              contenido que pueda constar en la cuenta personal del usuario,
              deslindando de responsabilidad a SUSHICORP. En caso de que exista
              algún uso no autorizado de su cuenta, el usuario se obliga a
              notificar el hecho de forma inmediata. El usuario no podrá enviar
              por correo electrónico o difundir por cualquier medio su
              identificación de usuario, contraseña o cualquier otra información
              que le permita acceder a la Plataforma Virtual. SUSHICORP no se
              hará responsable de la pérdida de información o el uso de un
              tercero, autorizado o no, de su cuenta y contraseña. Asimismo,
              SUSHICORP no será responsable por la pérdida o robo de información
              de los usuarios desde cualquier ordenador o dispositivo no
              autorizado.
            </p>
            <p className="Legal__paragraph">
              Contar con una cuenta no garantiza que el usuario reciba todas las
              notificaciones y ofertas de SUSHICORP, ni garantiza al usuario la
              disponibilidad de productos u ofertas. A través del uso y acceso a
              la Plataforma Virtual, los proveedores de SUSHICORP y SUSHICORP
              podrán recoger datos técnicos e información relacionada,
              incluyendo pero no limitado a información sobre su dispositivo,
              geolocalización, fecha y hora de acceso a la Plataforma Virtual,
              sistema y software de aplicación, y periféricos, la cual se
              reunirá periódicamente y será utilizada para el desarrollo de
              actualizaciones y mejoras de la Plataforma Virtual, así como la
              inclusión de nuevas funcionalidades. Asimismo, los usuarios
              autorizan a SUSHICORP a proporcionar contenido publicitario que
              SUSHICORP considere podría estar interesado el usuario, incluyendo
              los servicios de terceros que proporcionan contenido de
              publicidad.
            </p>
            <p className="Legal__paragraph">
              Si usted cree que un mensaje fue publicado en violación de los
              presentes términos y condiciones, por favor, copie el texto del
              mensaje en un correo electrónico y envíelo a
              <Link href="mailto:servicioalcliente@sushicorp.ec">
                servicioalcliente@sushicorp.ec
              </Link>
              . El usuario acepta que SUSHICORP no puede actuar como árbitro de
              los conflictos derivados de las comunicaciones de terceros u otro
              tipo de comunicaciones que se transmitan a la Plataforma Virtual.
              Para obtener más información sobre la presentación de quejas, por
              favor, póngase en contacto con{" "}
              <Link href="mailto:servicioalcliente@sushicorp.ec">
                servicioalcliente@sushicorp.ec
              </Link>
              .
            </p>
            <p className="Legal__paragraph">
              La información recopilada a través de la Plataforma Virtual, la
              que incluye, pero no se limita a nombre de usuario, contraseña,
              dirección de correo electrónico, dirección de domicilio,
              información financiera y de tarjetas de crédito o débito, no será
              transferida a terceros. SUSHICORP se obliga a no comercializar,
              vender, alquilar o ceder su base de datos a terceros. Conforme a
              las regulaciones y normas que rigen el comercio electrónico en el
              Ecuador, el usuario podrá solicitar a SUSHICORP que elimine de la
              base de datos su información
            </p>
          </div>
        </section>
      </main>
      <footer className="Legal__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

Legal.defaultProps = {};

export default Legal;
